import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'ups-modal-confirm',
    templateUrl: './modal-confirm.component.html',
    styleUrls: ['./modal-confirm.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ModalConfirmComponent {
  @Input() headerLabel = '';
  @Input() opened = false;
  @Input() confirmBtnLabel = 'Confirm';
  @Input() cancelBtnLabel = 'Cancel';
  @Input() cancelBtn: boolean = true;

  @Output() visibilityChanged: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() cancel: EventEmitter<void> = new EventEmitter();
  @Output() confirm: EventEmitter<void> = new EventEmitter();

  public onOpenChanged(isShown: boolean): void {
    this.opened = isShown;
    this.visibilityChanged.emit(this.opened);
  }

  public onCancel(): void {
    this.cancel.emit();
  }

  public onConfirm(): void {
    this.confirm.emit();
  }
}
